/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from "react";
import { oneLink } from "../../shared/oneLink";
import { MainLayout } from "../../components/Layout";
import { BrowserView, MobileView } from "react-device-detect";
import AppStoreLinks from "../../components/AppStoreLinks";
import "./styles.scss";

const logoSrc = require("../../assets/img/logo-long.svg").default;

const InstallAppPage = (): JSX.Element => {
    return (
        <MainLayout isBurgerHidden={true} autoWrapWideCard={false}>
            <section className="main">
                <MobileView>
                    <p>
                        アプリをインストールして
                        <br />
                        「新規登録の方はこちら」から始めてください。
                        <br />
                        お相手検索やお相手紹介、専任コンシェルジュに
                        <br />
                        よるサポートが利用できるようになります。
                    </p>
                </MobileView>
                <BrowserView>
                    <p>
                        <b>Next Step</b>
                        <br />
                        アプリをインストールして「新規登録の方はこちら」から始めてください。
                        <br />
                        お相手検索やお相手紹介、専任コンシェルジュに
                        <br />
                        よるサポートが利用できるようになります。
                    </p>
                </BrowserView>
                <img className="logo" src={logoSrc} />
                <AppStoreLinks linkTo={oneLink} />
            </section>
        </MainLayout>
    );
};

export default InstallAppPage;
